import React, { FunctionComponent } from 'react';
import ContactFormUpdateRepository from './contact-form-update-repository';
import ContactFormCreateRepository from './contact-form-create-repository';

export type ContactFormModalProps = {
  open: boolean;
  onClose: () => void;
};

type ContactFormProps = ContactFormModalProps & {
  contactId?: number | null;
  onContactCreated?: (contactId: number) => void;
  onContactUpdated?: (contactId: number) => void;
};

const ContactFormModal: FunctionComponent<ContactFormProps> = ({
  contactId,
  onContactCreated,
  onContactUpdated,
  ...rest
}) => {
  return (
    <>
      {contactId ? (
        <ContactFormUpdateRepository
          contactId={contactId}
          onContactUpdated={onContactUpdated}
          {...rest}
        />
      ) : (
        <ContactFormCreateRepository
          onContactCreated={onContactCreated}
          {...rest}
        />
      )}
    </>
  );
};

export default ContactFormModal;
